import useFaqPdfLink from 'hooks/useFaqPdfLink';
import { downloadFaq } from 'services/api/download';

import logosped from 'assets/images/logo-sped.jpg';

import {
  AccessTime,
  FacebookRounded,
  Instagram,
  LinkedIn,
  LocationOnOutlined,
  MailOutline,
  PhoneEnabled,
  PictureAsPdfOutlined,
  WhatsApp,
  YouTube,
} from '@mui/icons-material';
import { Link } from '@mui/material';

import {
  ContainerInfo,
  CopyrightLabel,
  FooterContainer,
  Logo,
  SocialIconButton,
  TypographyInfo,
  WrapperInfo,
  WrapperLogo,
  WrapperSocial,
} from './Footer.styles';

const Footer: React.FC = () => {
  const today = new Date();
  const faqPdfLink = useFaqPdfLink();

  return (
    <FooterContainer data-testid="footer-component">
      <ContainerInfo className="info">
        <WrapperLogo>
          <Logo src={logosped} alt="SPED Logo" />
        </WrapperLogo>
        <WrapperInfo>
          <TypographyInfo fontWeight={600}>Escritório</TypographyInfo>
          <TypographyInfo>
            <PhoneEnabled /> +55 (11) 4247-6492
          </TypographyInfo>
          <TypographyInfo>
            <WhatsApp /> +55 (11) 4858-7700
          </TypographyInfo>
          <TypographyInfo>
            <PhoneEnabled /> Financeiro: +55 (11) 4858-7050
          </TypographyInfo>
          <TypographyInfo>
            <LocationOnOutlined />
            Rua Carijós, 800 - Nova Americana. Americana-SP CEP: 13457-029
          </TypographyInfo>
        </WrapperInfo>
        <WrapperInfo>
          <TypographyInfo fontWeight={600}>Suporte Técnico</TypographyInfo>
          <TypographyInfo>
            <PictureAsPdfOutlined />
            <Link
              underline="hover"
              color="inherit"
              onClick={async () => downloadFaq(await faqPdfLink)}
              href="#"
              rel="noopener noreferrer"
            >
              FAQ - Perguntas Frequentes
            </Link>
          </TypographyInfo>
          <TypographyInfo>
            <MailOutline />
            <Link
              underline="hover"
              color="inherit"
              href="mailto:suporte@spedautomation.com.br"
            >
              suporte@spedautomation.com.br
            </Link>
          </TypographyInfo>
          <TypographyInfo>
            <AccessTime /> De seg. a sex. das 9h00 às 17h30
          </TypographyInfo>
        </WrapperInfo>
        <WrapperSocial>
          <Link
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.instagram.com/spedautomation"
          >
            <SocialIconButton>
              <Instagram />
            </SocialIconButton>
          </Link>
          <Link
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.facebook.com/spedautomation"
          >
            <SocialIconButton>
              <FacebookRounded />
            </SocialIconButton>
          </Link>
          <Link
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.linkedin.com/company/spedautomation"
          >
            <SocialIconButton>
              <LinkedIn />
            </SocialIconButton>
          </Link>
          <Link
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.youtube.com/channel/UCWJJYO1w_qbTy-RsCki4A9Q"
          >
            <SocialIconButton>
              <YouTube />
            </SocialIconButton>
          </Link>
        </WrapperSocial>
      </ContainerInfo>

      <CopyrightLabel>
        <Link
          underline="hover"
          color="inherit"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.spedautomation.com.br/"
        >
          © {today.getFullYear()} uma solução SPED Automation
        </Link>
      </CopyrightLabel>
    </FooterContainer>
  );
};

export default Footer;
